import { useHistory, useLocation } from 'react-router-dom';

const useNavigateWithSearch = () => {
  const history = useHistory();
  const location = useLocation();

  return (path: string, state?: any) => {
    history.push(path + location.search, state);
  };
};

export default useNavigateWithSearch;
